import React from "react";

export const TextCenter = (props: React.PropsWithChildren<{}>): JSX.Element => {
    return (
        <div style={{ textAlign: "center" }}>
            {props.children}
        </div>
    );
};
